import React, {useContext} from 'react';
import {Controller} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import Switch from '@src/components/Fields/Switch';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import useFormValue from '@src/hooks/useFormValue';

export function IsChargeBackField(props: IListColumnProps) {
    const {rowIndex: index} = props;
    const {
        control,
        fieldName,
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const [design] = useContext(FormFieldDesignContext);
    const {currentValue} = useFormValue(fieldName ?? '');
    const isExistedRecord = Boolean(currentValue?.[index].id);
    const initialValue = currentValue?.[index].is_charge_back;

    if (!control || isExistedRecord) {
        return initialValue ?
                <i className="fa-solid fa-check"/> :
                <i className="fa-solid fa-xmark"/>;
    }

    return <>
        <Controller
                control={control}
                name={`${fieldName}.${index}.is_charge_back`}
                render={({field: {name, value, onChange, onBlur}}) => {
                    return <Switch
                            id={name}
                            checked={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            label={undefined}
                            bsSize="sm"
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                    />;
                }}
        />

        <FormErrorMessage fieldName={`${fieldName}.${index}.is_charge_back`}/>
    </>;
}
